module.exports = "/fonts/salesforce-sans.ttf?0fadaa21fcac88ceee0bb8da992c221b";